import { Injectable } from '@angular/core';
import { ApolloCache, FetchResult } from '@apollo/client/core';
import { Observable } from 'rxjs';

import { CreateTag, CreateTagGQL, TagType } from 'generated/graphql';

import { invalidateApolloCacheFor } from 'core/apollo-cache-invalidator';

import type { AddressInput} from 'generated/graphql';
@Injectable({
  providedIn: 'root'
})
export class TagCreationService {

  constructor(
    private createTagGQL: CreateTagGQL
  ) {
  }

  addNewTag(
    tagType: TagType,
    tagCategoryId: string,
    name: string,
    campaignId?: string,
    address?: AddressInput
  ) {

    const $mutation = this._buildMutation(tagType, tagCategoryId, name, campaignId, address);

    return $mutation;
  }

  private _buildMutation(
    tagType: TagType,
    tagCategoryId: string,
    name: string,
    campaignId?: string,
    address?: AddressInput
  ): Observable<FetchResult<CreateTag.Mutation>> {
    const isInCampaignId = campaignId;

    const input = {
      tagType,
      tagCategoryId,
      name,
      campaignId,
      address
    };

    const mutationOptions = {
      update(cache: ApolloCache<any>, data: any) {
        invalidateApolloCacheFor(
          cache,
          (o) => o.args?.tagCategoryIds?.includes(tagCategoryId)
        );
        invalidateApolloCacheFor(
          cache,
          (c) => c.fieldName.includes('getTagGroups')
        );
      }
    };

    return this.createTagGQL.mutate(
      { input, isInCampaignId },
      mutationOptions
    );
  }
}
